import { IRFPLaneRate } from '../api/rfpLaneRates'
import { IRFPLane } from '../api/rfpLanes'

export const extractRfpLaneFromRate = (rfpLaneRate?: IRFPLaneRate): IRFPLane => {
  const {
    id = '',
    pickupDatMarket = '',
    deliveryDatMarket = '',
    pickupCity = '',
    pickupStateCode = '',
    deliveryCity = '',
    deliveryStateCode = '',
    equipment = { id: '', key: '', name: '', parentId: '', position: '' },
    rfpLaneDropType = '',
    requestForProposal,
  } = rfpLaneRate || {}
  const { rfpTitle = '', salesforceRfpId = '', shipperName = '' } = requestForProposal || {}
  const newEquipment = {
    id: String(equipment.id) || '',
    key: equipment.key || '',
    name: equipment.name || '',
    parentId: String(equipment.parentId) || '',
    position: String(equipment.position) || '',
  }
  return {
    id: String(id),
    laneId: '',
    rfpTitle,
    shipperName,
    salesforceRfpId,
    pickupDatMarket: pickupDatMarket || '',
    deliveryDatMarket: deliveryDatMarket || '',
    pickupCity: pickupCity || '',
    pickupStateCode: pickupStateCode || '',
    deliveryCity: deliveryCity || '',
    deliveryStateCode: deliveryStateCode || '',
    equipment: newEquipment,
    dropType: rfpLaneDropType || '',
  }
}
